// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("img/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-family: "Montserrat", sans-serif;
}

h1 {
  font-size: 40px;
  color: #5b75de;
  font-weight: 400;
  margin: 0;
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  margin-top: 15px;
}

h2 {
  font-size: 40px;
  color: #5b75de;
  font-weight: 400;
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  padding-top: 20px;
  margin-top: 15px;
}

h3 {
  font-weight: 100;
  margin: 0;
  padding: 0;
  margin-bottom: 20px;
  line-height: 24px;
}

p, li, ol, ul {
  font-weight: 100;
  font-size: 20px;
  line-height: 30px;
  font-weight: 400;
}

p {
  margin-bottom: 25px;
}

ul {
  margin-left: 0;
  padding-left: 15px;
}

strong {
  font-weight: 600;
  color: #494949;
  font-size: 21px;
}

p a {
  color: rgb(0, 52, 164);
  text-decoration: none;
  border-bottom: 1px solid rgb(0, 52, 164);
  padding-bottom: 1px;
}

@media screen and (min-width: 768px) {
  h1 {
    font-size: 70px;
  }
  h2 {
    font-size: 65px;
  }
}
html {
  scrollbar-gutter: stable;
}

body {
  background-color: #494949;
}

@media screen and (min-width: 768px) {
  body {
    background-color: #494949;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top;
  }
}
.logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 160px;
  display: none;
}

.logo img {
  width: 100%;
}

@media screen and (min-width: 950px) {
  .logo {
    display: block;
  }
}
.container {
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background-color: white;
}

@media screen and (min-width: 768px) {
  .container {
    width: 70%;
    margin: 0 auto;
    min-height: 100vh;
    background-color: white;
  }
}
.mainillustration {
  width: 100%;
}

.mainillustration img {
  width: 100%;
  display: block;
}

.content {
  padding: 30px;
}

.subkop {
  padding: 5px 10px;
  background-color: rgb(255, 234, 46);
  font-family: "Montserrat", sans-serif;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  font-weight: 500;
}

.kader {
  background-color: rgb(255, 234, 46);
  padding: 2px 30px 15px 30px;
  border-radius: 20px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.grid > div {
  background-color: rgb(255, 234, 46);
  padding: 15px 30px;
  text-align: center;
  font-size: 20px;
  line-height: 30px;
  border-radius: 20px;
}

.grid > div > img {
  display: block;
  width: 100%;
}

.grid2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.grid2 > div {
  padding: 15px 30px;
  text-align: center;
  font-size: 20px;
  line-height: 30px;
  border-radius: 20px;
}

.grid2 > div > img {
  display: block;
  width: 140px;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }
  .grid2 {
    padding: 0px;
    grid-template-columns: repeat(1, 1fr);
  }
  .grid2 > div {
    padding: 0;
  }
  .grid2 > div > img {
    display: block;
    width: 100px;
    margin: 0 auto;
  }
}
.bus {
  display: block;
  margin: 0;
  padding: 0;
}

.bus img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/sass/02_layout/_typo.scss","webpack://./src/sass/02_layout/index.scss","webpack://./src/sass/02_layout/_colours.scss","webpack://./src/sass/02_layout/_body.scss","webpack://./src/sass/02_layout/_logo.scss","webpack://./src/sass/02_layout/_container.scss","webpack://./src/sass/02_layout/_mainillustration.scss","webpack://./src/sass/02_layout/_content.scss","webpack://./src/sass/02_layout/_subkop.scss","webpack://./src/sass/02_layout/_kader.scss","webpack://./src/sass/02_layout/_grid.scss","webpack://./src/sass/02_layout/_bus.scss"],"names":[],"mappings":"AAEA;EACI,qCAAA;ACDJ;;ADKA;EACI,eAAA;EACA,cELQ;EFMR,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ACFJ;;ADKA;EACI,eAAA;EACA,cEhBQ;EFiBR,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;ACFJ;;ADMA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;ACHJ;;ADMA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ACHJ;;ADMA;EACI,mBAAA;ACHJ;;ADMA;EACI,cAAA;EACA,kBAAA;ACHJ;;ADMA;EACI,gBAAA;EACA,cEnDO;EFoDP,eAAA;ACHJ;;ADMA;EACI,sBE5DG;EF6DH,qBAAA;EACA,wCAAA;EACA,mBAAA;ACHJ;;ADMA;EACI;IACA,eAAA;ECHF;EDME;IACA,eAAA;ECJF;AACF;AEpEA;EACI,wBAAA;AFsEJ;;AEnEA;EACI,yBDLG;AD2EP;;AEnEA;EACI;IACI,yBDVD;ICWC,yDAAA;IACA,wBAAA;IACA,4BAAA;IACA,wBAAA;EFsEN;AACF;AGvFA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AHyFJ;;AGtFA;EACI,WAAA;AHyFJ;;AGtFA;EACI;IACI,cAAA;EHyFN;AACF;AIxGA;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AJ0GJ;;AIvGA;EACI;IACA,UAAA;IACA,cAAA;IACA,iBAAA;IACA,uBAAA;EJ0GF;AACF;AKvHA;EACI,WAAA;ALyHJ;;AKtHA;EACI,WAAA;EACA,cAAA;ALyHJ;;AM7HA;EACI,aAAA;ANgIJ;;AOhIA;EACI,iBAAA;EACA,mCNLK;EMML,qCAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;APmIJ;;AQ1IA;EACI,mCPJK;EOKL,2BAAA;EACA,mBAAA;AR6IJ;;ASjJA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AToJJ;;ASjJA;EACI,mCRTK;EQUL,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AToJJ;;ASjJA;EACI,cAAA;EACA,WAAA;AToJJ;;ASjJA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AToJJ;;ASjJA;EACI,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AToJJ;;ASjJA;EACI,cAAA;EACA,YAAA;EACA,cAAA;AToJJ;;ASjJA;EACI;IACI,qCAAA;IACA,SAAA;EToJN;ESlJE;IACA,YAAA;IACA,qCAAA;EToJF;ESjJF;IACI,UAAA;ETmJF;EShJF;IACI,cAAA;IACA,YAAA;IACA,cAAA;ETkJF;AACF;AU9MA;EACI,cAAA;EACA,SAAA;EACA,UAAA;AVgNJ;;AU7MA;EACI,WAAA;AVgNJ","sourcesContent":["@use 'colours';\n\nhtml {\n    font-family: \"Montserrat\", sans-serif;\n}\n\n\nh1 {\n    font-size: 40px;\n    color: colours.$lightblue;\n    font-weight: 400;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 30px;\n    text-transform: uppercase;\n    margin-top: 15px;\n}\n\nh2 {\n    font-size: 40px;\n    color: colours.$lightblue;\n    font-weight: 400;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 10px;\n    padding-top: 20px;\n    margin-top: 15px;\n}\n\n\nh3 {\n    font-weight: 100;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 20px;\n    line-height: 24px;\n}\n\np, li, ol, ul {\n    font-weight: 100;\n    font-size: 20px;\n    line-height: 30px;\n    font-weight: 400;\n}\n\np {\n    margin-bottom: 25px;\n}\n\nul {\n    margin-left: 0;\n    padding-left: 15px;\n}\n\nstrong {\n    font-weight: 600;\n    color: colours.$darkgrey;\n    font-size: 21px;\n}\n\np a {\n    color: colours.$blue;\n    text-decoration: none;\n    border-bottom: 1px solid colours.$blue;\n    padding-bottom: 1px;\n}\n\n@media screen and (min-width: 768px) {\n    h1 {\n    font-size: 70px;\n    }\n\n    h2 {\n    font-size: 65px;\n}\n}","html {\n  font-family: \"Montserrat\", sans-serif;\n}\n\nh1 {\n  font-size: 40px;\n  color: #5b75de;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 30px;\n  text-transform: uppercase;\n  margin-top: 15px;\n}\n\nh2 {\n  font-size: 40px;\n  color: #5b75de;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 10px;\n  padding-top: 20px;\n  margin-top: 15px;\n}\n\nh3 {\n  font-weight: 100;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 20px;\n  line-height: 24px;\n}\n\np, li, ol, ul {\n  font-weight: 100;\n  font-size: 20px;\n  line-height: 30px;\n  font-weight: 400;\n}\n\np {\n  margin-bottom: 25px;\n}\n\nul {\n  margin-left: 0;\n  padding-left: 15px;\n}\n\nstrong {\n  font-weight: 600;\n  color: #494949;\n  font-size: 21px;\n}\n\np a {\n  color: rgb(0, 52, 164);\n  text-decoration: none;\n  border-bottom: 1px solid rgb(0, 52, 164);\n  padding-bottom: 1px;\n}\n\n@media screen and (min-width: 768px) {\n  h1 {\n    font-size: 70px;\n  }\n  h2 {\n    font-size: 65px;\n  }\n}\nhtml {\n  scrollbar-gutter: stable;\n}\n\nbody {\n  background-color: #494949;\n}\n\n@media screen and (min-width: 768px) {\n  body {\n    background-color: #494949;\n    background-image: url(\"img/background.png\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: top;\n  }\n}\n.logo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 160px;\n  display: none;\n}\n\n.logo img {\n  width: 100%;\n}\n\n@media screen and (min-width: 950px) {\n  .logo {\n    display: block;\n  }\n}\n.container {\n  width: 100%;\n  margin: 0 auto;\n  min-height: 100vh;\n  background-color: white;\n}\n\n@media screen and (min-width: 768px) {\n  .container {\n    width: 70%;\n    margin: 0 auto;\n    min-height: 100vh;\n    background-color: white;\n  }\n}\n.mainillustration {\n  width: 100%;\n}\n\n.mainillustration img {\n  width: 100%;\n  display: block;\n}\n\n.content {\n  padding: 30px;\n}\n\n.subkop {\n  padding: 5px 10px;\n  background-color: rgb(255, 234, 46);\n  font-family: \"Montserrat\", sans-serif;\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n  font-weight: 500;\n}\n\n.kader {\n  background-color: rgb(255, 234, 46);\n  padding: 2px 30px 15px 30px;\n  border-radius: 20px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.grid > div {\n  background-color: rgb(255, 234, 46);\n  padding: 15px 30px;\n  text-align: center;\n  font-size: 20px;\n  line-height: 30px;\n  border-radius: 20px;\n}\n\n.grid > div > img {\n  display: block;\n  width: 100%;\n}\n\n.grid2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.grid2 > div {\n  padding: 15px 30px;\n  text-align: center;\n  font-size: 20px;\n  line-height: 30px;\n  border-radius: 20px;\n}\n\n.grid2 > div > img {\n  display: block;\n  width: 140px;\n  margin: 0 auto;\n}\n\n@media screen and (max-width: 768px) {\n  .grid {\n    grid-template-columns: repeat(1, 1fr);\n    gap: 10px;\n  }\n  .grid2 {\n    padding: 0px;\n    grid-template-columns: repeat(1, 1fr);\n  }\n  .grid2 > div {\n    padding: 0;\n  }\n  .grid2 > div > img {\n    display: block;\n    width: 100px;\n    margin: 0 auto;\n  }\n}\n.bus {\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n\n.bus img {\n  width: 100%;\n}","$yellow: rgb(255, 234, 46);\n$blue: rgb(0, 52, 164);\n$grey: #494949;\n$black: #000;\n$lightblue: #5b75de;\n$darkgrey: #494949;","@use 'colours';\n\nhtml {\n    scrollbar-gutter: stable;\n}\n\nbody {\n    background-color: colours.$grey;\n}\n\n@media screen and (min-width: 768px) {\n    body {\n        background-color: colours.$grey;\n        background-image: url('img/background.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        background-position: top;\n    }\n}\n\n\n",".logo {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 160px;\n    display: none;\n}\n\n.logo img {\n    width: 100%;\n}\n\n@media screen and (min-width: 950px) {\n    .logo {\n        display: block;\n    }\n}",".container {\n    width: 100%;\n    margin: 0 auto;\n    min-height: 100vh;\n    background-color: white;\n}\n\n@media screen and (min-width: 768px) {\n    .container {\n    width: 70%;\n    margin: 0 auto;\n    min-height: 100vh;\n    background-color: white;\n}\n    \n}",".mainillustration {\n    width: 100%;\n}\n\n.mainillustration img {\n    width: 100%;\n    display: block;\n}","@use 'colours';\n\n.content {\n    padding: 30px;\n}","\n@use 'colours';\n\n.subkop {\n    padding: 5px 10px;\n    background-color: colours.$yellow;\n    font-family: \"Montserrat\", sans-serif;\n    display: inline-block;\n    text-transform: uppercase;\n    letter-spacing: 0.2px;\n    font-weight: 500;\n}","@use 'colours';\n\n\n.kader {\n    background-color: colours.$yellow;\n    padding: 2px 30px 15px 30px;\n    border-radius: 20px;\n}","@use 'colours';\n\n.grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n}\n\n.grid > div {\n    background-color: colours.$yellow;\n    padding: 15px 30px;\n    text-align: center;\n    font-size: 20px;\n    line-height: 30px;\n    border-radius: 20px;\n}\n\n.grid > div > img {\n    display: block;\n    width: 100%;\n}\n\n.grid2 {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n\n.grid2 > div {\n    padding: 15px 30px;\n    text-align: center;\n    font-size: 20px;\n    line-height: 30px;\n    border-radius: 20px;\n}\n\n.grid2 > div > img {\n    display: block;\n    width: 140px;\n    margin: 0 auto;\n}\n\n@media screen and (max-width: 768px) {\n    .grid {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 10px;\n    }\n    .grid2 {\n    padding: 0px;\n    grid-template-columns: repeat(1, 1fr);\n}\n\n.grid2 > div {\n    padding: 0;\n}\n\n.grid2 > div > img {\n    display: block;\n    width: 100px;\n    margin: 0 auto;\n}\n    \n}",".bus {\n    display: block;\n    margin: 0;\n    padding: 0;\n}\n\n.bus img {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
